import { Component, ElementRef, Input, OnDestroy, ViewChild } from '@angular/core';
import * as echarts from 'echarts';

@Component({
    selector: 'app-bar-graph',
    templateUrl: './bar-graph.component.html',
    styleUrl: './bar-graph.component.scss',
    standalone: false
})
export class BarGraphComponent implements OnDestroy {
  @ViewChild('chart', { static: true }) chartElement!: ElementRef;
  chartOption: any;
  @Input() colors: any;
  @Input() data: number[];
  @Input() type: string;
  @Input() title: string;
  windowWidth: number;

  private chartInstance: echarts.ECharts | null = null;
  private resizeHandler = () => this.onResize();

  ngAfterViewInit(): void {
    this.initChart();
    window.addEventListener('resize', this.resizeHandler);
  }

  ngOnDestroy(): void {
    window.removeEventListener('resize', this.resizeHandler);
    if (this.chartInstance) {
      this.chartInstance.dispose();
    }
  }

  private initChart(): void {
    const chartDom = this.chartElement.nativeElement;
    this.chartInstance = echarts.init(chartDom);
    this.setChartOption();
  }

  private setChartOption(): void {
    if (!this.chartInstance) return;
    if (this.type === 'temp') {
      this.chartInstance.setOption(this.getTempOption());
    } else {
    this.chartInstance.setOption(this.getBarOption());
    }
  }

  private onResize(): void {
    this.windowWidth = window.outerWidth;
    console.log(this.windowWidth);
    if (this.chartInstance) {
      this.chartInstance.resize();
    }
  }

  private getBarOption(): any {
    const baseFontSize = window.innerWidth <= 1200 ? 10 : window.innerWidth <= 1600 ? 11 : 12;
    const labelFontSize = window.innerWidth <= 1200 ? 12 : window.innerWidth <= 1600 ? 13 : 14;
    
    this.chartOption = {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        },
        textStyle: {
          fontSize: baseFontSize
        },
        formatter: (params: any) => {
          return `${params[0].marker} ${params[0].name}: ${params[0].value}`;
        }
      },
      xAxis: {
        type: 'category',
        data: ['Base Case', 'Design Case'],
        axisTick: {
          alignWithLabel: true
        },
        axisLabel: {
          fontWeight: 'bold',
          fontSize: baseFontSize
        }
      },
      yAxis: {
        show: false // ⛔ Hides the entire Y axis
      },
      series: [
        {
          name: 'Case Comparison',
          type: 'bar',
          barWidth: '40%',
          data: [
            {
              value: this.data[0],
              itemStyle: { color: '#ca1b1c' }
            },
            {
              value: this.data[1],
              itemStyle: { color: '#0d8f37' }
            }
          ],
          label: {
            show: true,
            position: 'top',
            fontSize: labelFontSize,
            fontWeight: 'bold',
            color: '#000',
            formatter: (params: any) => `${params.value} Kg CO₂`
          }
        }
      ]
    };

    return { ...this.chartOption };
  }

  private getTempOption(): any {
    const baseFontSize = window.innerWidth <= 1200 ? 12 : window.innerWidth <= 1600 ? 13 : 14;
    const labelFontSize = window.innerWidth <= 1200 ? 14 : window.innerWidth <= 1600 ? 15 : 16;
    
    this.chartOption = {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        },
        textStyle: {
          fontSize: baseFontSize + 2
        },
        formatter: (params: any) => {
          return `${params[0].marker} ${params[0].name}: ${params[0].value}`;
        }
      },
      xAxis: {
        type: 'category',
        data: ['Base Case', 'Design Case'],
        axisTick: {
          alignWithLabel: true
        },
        axisLabel: {
          fontWeight: 'bold',
          fontSize: baseFontSize
        }
      },
      yAxis: {
        show: false // ⛔ Hides the entire Y axis
      },
      series: [
        {
          name: 'Case Comparison',
          type: 'bar',
          barWidth: '40%',
          data: [
            {
              value: this.data[0],
              itemStyle: { color: '#ca1b1c' }
            },
            {
              value: this.data[1],
              itemStyle: { color: '#0d8f37' }
            }
          ],
          label: {
            show: true,
            position: 'top',
            fontSize: labelFontSize,
            fontWeight: 'bold',
            color: '#000',
            formatter: (params: any) => `${params.value} °C`
          }
        }
      ]
    };

    return { ...this.chartOption };
  }

}
